import {
  getShoppingData
} from 'actions/shoppingData'
import dayjs from 'dayjs'
import { rest } from 'services'

const { api } = rest

export const getAppointmentDatesAndSlots = ({ date, setDateData }) => dispatch => {
  if (date) {
    const currentDate = dayjs(date.split(' ')[0], 'MM-DD-YYYY').format('MM/DD/YYYY')

    dispatch(getShoppingData(api.getTAOSAppointmentDatesAndSlots, {
      isFromOnlineAppointment: false,
      availableDate: currentDate
    }))
      .then(({ appointmentDetailsResponseVO: { appointmentDateAndSlotsVO }}) => setDateData(appointmentDateAndSlotsVO))
      .catch(e => {
        console.error(e)
      })
  } else {
    dispatch(getShoppingData(api.getTAOSAppointmentDatesAndSlots, {
      isFromOnlineAppointment: false
    }))
      .then(({ appointmentDetailsResponseVO: { appointmentDateAndSlotsVO }}) => setDateData(appointmentDateAndSlotsVO))
      .catch(e => {
        console.error(e)
      })
  }
}
